import { render } from "./ModifiersDialog.vue?vue&type=template&id=d9df7a88"
import script from "./ModifiersDialog.vue?vue&type=script&lang=js"
export * from "./ModifiersDialog.vue?vue&type=script&lang=js"

import "./ModifiersDialog.vue?vue&type=style&index=0&id=d9df7a88&lang=scss"
script.render = render

export default script